import { Chart, type WorkingOrder, type AlertSpec } from './Chart';
import type { BrokerClient } from '../api/brokerClient';

export type GridLayout = '1x1' | '2x2' | '3x2';

export interface ChartCellSpec {
  symbol: string;
  symbolLongName?: string;
  price: number;
  pctChange: number;
  alerts?: AlertSpec[];
  earningsDates?: number[];
  dividendsDates?: number[];
  positionAvgPrice?: number;
  positionQuantity?: number;
}

interface Props {
  cells: ChartCellSpec[];
  onSelect?: (sym: string) => void;
  workingOrders?: WorkingOrder[];
  brokerClient?: BrokerClient;
  brokerId?: string;
  single?: boolean;
  layout?: GridLayout;
  onQuickTrade?: (side: 'BUY' | 'SELL', symbol: string, price: number) => void;
}

const LAYOUT_CELLS: Record<GridLayout, number> = { '1x1': 1, '2x2': 4, '3x2': 6 };

export function ChartsGrid({ cells, onSelect, workingOrders, brokerClient, brokerId, single, layout = '2x2', onQuickTrade }: Props) {
  const filtered = (sym: string) => workingOrders?.filter((o: any) => (o.symbol ?? sym) === sym);
  const effectiveLayout: GridLayout = single ? '1x1' : layout;
  const n = LAYOUT_CELLS[effectiveLayout];

  if (effectiveLayout === '1x1') {
    const c = cells[0]; if (!c) return null;
    return (
      <div style={{ height: '100%' }} onClick={() => onSelect?.(c.symbol)}>
        <Chart {...c} workingOrders={filtered(c.symbol)} brokerClient={brokerClient} brokerId={brokerId} height={520} onQuickTrade={onQuickTrade} />
      </div>
    );
  }

  const heightPx = effectiveLayout === '3x2' ? 320 : 360;

  return (
    <div className={`charts-grid layout-${effectiveLayout}`} role="region" aria-label="Charts grid">
      {cells.slice(0, n).map((c) => (
        <div key={c.symbol} className="chart-cell" onClick={() => onSelect?.(c.symbol)}>
          <Chart {...c} workingOrders={filtered(c.symbol)} brokerClient={brokerClient} brokerId={brokerId} height={heightPx} onQuickTrade={onQuickTrade} />
        </div>
      ))}
    </div>
  );
}
